import {
    AffiliateLayout,
    DefaultLayout,
    ForbiddenLayout,
    LandLayout,
    LightLayout,
    OfferLayout,
    SubscriptionsLayout,
    ToolsLayout,
} from '@layout';
import { ILayoutProps } from '@layout/default';

// eslint-disable-next-line import/prefer-default-export
export const getLayoutByPathname = (pathname: string): React.FC<ILayoutProps> => {
    if (typeof pathname !== 'string') return DefaultLayout;
    if (pathname.length === 0) return DefaultLayout;
    let section = pathname.split('/')[2] || 'main';

    if (pathname.includes('detail') || pathname === '/[locale]/campaigns/add') section = 'offer';
    if (pathname === '/[locale]/integrations' || pathname === '/[locale]/integrations/add')
        section = 'integrationsPage';

    switch (section) {
        case 'auth':
        case 'main':
            return LandLayout;
        case 'tools':
            return ToolsLayout;
        case 'subscriptions':
        case 'privacy':
        case 'rules':
            return SubscriptionsLayout;
        case 'affiliate':
            return AffiliateLayout;
        case 'forbidden':
            return ForbiddenLayout;
        case 'offer':
            return OfferLayout;
        case 'profile':
        case 'integrationsPage':
        case 'campaigns':
        case 'bloggers':
            return LightLayout;
        case 'placements':
            return LightLayout;
        default:
            return DefaultLayout;
    }
};
